import React from 'react'
import PropTypes from 'prop-types'
import { MasteryPoints } from '../Screens/MasteryPoints/main.js'

const MasteryPointsPage = ({ data }) => {
  return <MasteryPoints data={data} />
}

MasteryPointsPage.propTypes = {
  data: PropTypes.object.isRequired
}

export default MasteryPointsPage
